<template>
  <div>
    <PersonInfo :v="v" />

    <v-checkbox
      v-model="v.isTrustee.$model"
      label="Подать заявление как представитель заявителя"
      hide-details
    />

    <template v-if="v.isTrustee.$model">
      <div class="form-section-base__controls">
        <v-radio-group v-model="v.trusteeType.$model" row>
          <v-radio
            label="Представитель заявителя по нотариально заверенной доверенности в бумажном виде"
            :value="TrusteeType.TRUSTEE"
          />
          <v-radio
            label="Законный представитель физического лица (без доверенности)"
            :value="TrusteeType.ASSIGNEE"
          />
        </v-radio-group>
      </div>

      <PersonTrustee
        v-if="v.trusteeType.$model === TrusteeType.TRUSTEE"
        :v="v.trustee"
      />

      <Assignee
        v-if="v.trusteeType.$model === TrusteeType.ASSIGNEE"
        :v="v.assignee"
        :label="TrusteeLabel.PERSON"
      />
    </template>
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import {
  Mask,
  SubjectFillTypeText,
  TrusteeLabel,
  TrusteeType,
} from '@/constants';
import PersonTrustee, {
  personTrusteeModel,
  getPersonTrusteeValidation,
} from '@/components/services/EgrnConfirm/Applicant/components/Person/PersonTrustee';
import PersonInfo, {
  personInfoModel,
  personInfoValidation,
  prefillEsiaPersonInfo,
} from '@/components/services/EgrnConfirm/Applicant/components/Person/PersonInfo';
import Assignee, {
  assigneeModel,
  getAssigneeValidation,
} from '@/components/services/EgrnConfirm/Applicant/components/Assignee';
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';

export const mrpaDisablePersonModel = {
  ...cloneDeep(personInfoModel),
  isTrustee: false,
  trusteeType: TrusteeType.TRUSTEE,
  trustee: cloneDeep(personTrusteeModel),
  assignee: cloneDeep(assigneeModel),
};

export const getMrpaDisablePersonValidation = (person) => {
  const personValidation = {
    ...personInfoValidation,
    isTrustee: {},
  };

  if (!person.isTrustee) return personValidation;

  personValidation.trusteeType = {};

  if (person.trusteeType === TrusteeType.TRUSTEE) {
    personValidation.trustee = getPersonTrusteeValidation(person.isTrustee);

    return personValidation;
  }

  personValidation.assignee = getAssigneeValidation(person.assignee);

  return personValidation;
};

export const prefillEsiaMrpaDisablePerson = async () => {
  const esiaPersonInfo = await prefillEsiaPersonInfo();

  return deepmerge(mrpaDisablePersonModel, esiaPersonInfo);
};

export default {
  name: 'MrpaDisablePerson',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    PersonInfo,
    PersonTrustee,
    Assignee,
  },
  data: () => ({
    Mask,
    SubjectFillTypeText,
    TrusteeType,
    TrusteeLabel,
    getValidationErrorText,
  }),
};
</script>
